<script setup lang="ts">
  import { Slider } from '@rapoo/element'
  import { DEFAULT_AUDIO_RHYTHM_SETTINGS, type AudioRhythmSettings } from '@rapoo/device-sdk'

  defineOptions({ name: 'AudioRhythmSettings' })

  const settings = defineModel<AudioRhythmSettings>({
    default: () => ({ ...DEFAULT_AUDIO_RHYTHM_SETTINGS }),
  })

  const sliderItems: {
    key: keyof AudioRhythmSettings
    i18nKey: string
    min: number
    max: number
  }[] = [
    {
      key: 'lowSensitivity',
      i18nKey: 'lighting.audioRhythmSettings.lowSensitivity',
      min: 0,
      max: 200,
    },
    {
      key: 'midSensitivity',
      i18nKey: 'lighting.audioRhythmSettings.midSensitivity',
      min: 0,
      max: 200,
    },
    {
      key: 'highSensitivity',
      i18nKey: 'lighting.audioRhythmSettings.highSensitivity',
      min: 0,
      max: 200,
    },
    {
      key: 'brightness',
      i18nKey: 'lighting.audioRhythmSettings.brightness',
      min: 0,
      max: 100,
    },
    {
      key: 'trailSmoothing',
      i18nKey: 'lighting.audioRhythmSettings.trailSmoothing',
      min: 0,
      max: 100,
    },
  ]

  const updateSetting = (key: keyof AudioRhythmSettings, value: number[] | undefined) => {
    const next = value?.[0]
    if (next == null) return
    settings.value = { ...settings.value, [key]: next }
  }
</script>

<template>
  <div class="glass-frosted w-118 rounded-8xl p-4 relative max-h-70 box-border flex flex-col">
    <div class="text-l-medium text-black-white">
      {{ $t('lighting.audioRhythmSettings.title') }}
    </div>
    <div class="mt-3 flex flex-1 flex-col justify-between gap-3">
      <div v-for="item in sliderItems" :key="item.key" class="flex items-center gap-3">
        <span class="w-24 shrink-0 text-m-medium text-black-white">
          {{ $t(item.i18nKey) }}
        </span>
        <Slider
          :model-value="[settings[item.key]]"
          :min="item.min"
          :max="item.max"
          :step="1"
          class="w-full min-w-0 flex-1"
          @update:model-value="(val) => updateSetting(item.key, val)"
        />
        <span class="w-10 shrink-0 text-right text-s-medium text-black-white tabular-nums">
          {{ settings[item.key] }}%
        </span>
      </div>
    </div>
  </div>
</template>
